import { render, staticRenderFns } from "./WorkClientTableItem.vue?vue&type=template&id=44c86b58&scoped=true&"
import script from "./WorkClientTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkClientTableItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientTableItem.vue?vue&type=style&index=0&id=44c86b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c86b58",
  null
  
)

export default component.exports